import { is, roles } from '../../utility/guard';
import { DashboardRoute } from '../types';
import UsersContainer from '../../views/users/UserList';
import OrganizationList from '../../views/organizations/OrganizationList';
import OrganizationForm from '../../views/organizations/OrganizationForm';
import CustomersList from '../../views/customers/CustomersList';
import CustomerEdit from '../../views/customers/CustomerEdit';
import CustomerCreate from '../../views/customers/CustomerCreate';
import VideoList from '../../views/videos/VideoList';
import VideoCreate from '../../views/videos/VideoCreate';
import VideoEdit from '../../views/videos/VideoEdit';
import VideoMenuList from '../../views/video-menus/VideoMenuList';
import VideoMenuCreate from '../../views/video-menus/VideoMenuCreate';
import VideoMenuEdit from '../../views/video-menus/VideoMenuEdit';
import User from '../../views/users/User';
import PromotionCodeList from '../../views/promotion-codes/PromotionCodeList';
import PromotionCodeCreate from '../../views/promotion-codes/PromotionCodeCreate';
import PromotionCodeEdit from '../../views/promotion-codes/PromotionCodeEdit';
import OrderCreate from '../../views/orders/OrderCreate';
import OrderEdit from '../../views/orders/OrderEdit';
import OrderList from '../../views/orders/OrderList';

const { superAdmin } = roles;

export const userList = {
  path: '/dashboard/admin/users',
  component: UsersContainer,

  guard: is(superAdmin),
} as DashboardRoute;

export const userEdit = {
  path: [
    '/dashboard/admin/users/:id',
    '/dashboard/admin/users/:id/profile',
    '/dashboard/admin/users/:id/billing/plan',
    '/dashboard/admin/users/:id/billing/payment-method',
    '/dashboard/admin/users/:id/billing/invoices',
    '/dashboard/admin/users/:id/billing/credit-history',
    '/dashboard/admin/users/:id/admin',
    '/dashboard/admin/users/:id/notifications',
  ],
  component: User,

  guard: is(superAdmin),
} as DashboardRoute;

export const organizationList = {
  path: '/dashboard/admin/organizations',
  component: OrganizationList,

  guard: is(superAdmin),
} as DashboardRoute;

export const organizationForm = {
  path: [
    '/dashboard/admin/organizations/new',
    '/dashboard/admin/organizations/:id',
    '/dashboard/admin/organizations/:id/account',
    '/dashboard/admin/organizations/:id/billing',
    '/dashboard/admin/organizations/:id/team',
    '/dashboard/admin/organizations/:id/team/new',
    '/dashboard/admin/organizations/:id/team/:teamId',
  ],
  component: OrganizationForm,

  guard: is(superAdmin),
} as DashboardRoute;

export const customerList = {
  path: '/dashboard/admin/customers',
  component: CustomersList,

  guard: is(superAdmin),
} as DashboardRoute;

export const customerCreate = {
  path: '/dashboard/admin/customers/new',
  component: CustomerCreate,

  guard: is(superAdmin),
} as DashboardRoute;

export const customerDetail = {
  path: '/dashboard/admin/customers/:id',
  component: CustomerEdit,

  guard: is(superAdmin),
} as DashboardRoute;

export const videoList = {
  path: '/dashboard/admin/videos',
  component: VideoList,

  guard: is(superAdmin),
} as DashboardRoute;

export const videoCreate = {
  path: '/dashboard/admin/videos/new',
  component: VideoCreate,

  guard: is(superAdmin),
} as DashboardRoute;

export const videoEdit = {
  path: '/dashboard/admin/videos/:id',
  component: VideoEdit,

  guard: is(superAdmin),
} as DashboardRoute;

export const videoMenuList = {
  path: '/dashboard/admin/video-menus',
  component: VideoMenuList,

  guard: is(superAdmin),
} as DashboardRoute;

export const videoMenuCreate = {
  path: '/dashboard/admin/video-menus/new',
  component: VideoMenuCreate,

  guard: is(superAdmin),
} as DashboardRoute;

export const videoMenuEdit = {
  path: [
    '/dashboard/admin/video-menus/:id',
    '/dashboard/admin/video-menus/:id/info',
    '/dashboard/admin/video-menus/:id/videos',
    '/dashboard/admin/video-menus/:id/menus',
    '/dashboard/admin/video-menus/:id/presentation',
    '/dashboard/admin/video-menus/:id/options',
    '/dashboard/admin/video-menus/:id/format',
    '/dashboard/admin/video-menus/:id/social-media',
  ],
  component: VideoMenuEdit,

  guard: is(superAdmin),
} as DashboardRoute;

export const promotionCodeCreateRoute = {
  path: '/dashboard/admin/promotion-codes/new',
  component: PromotionCodeCreate,

  guard: is(superAdmin),
} as DashboardRoute;

export const promotionCodeEditRoute = {
  path: '/dashboard/admin/promotion-codes/:id',
  component: PromotionCodeEdit,

  guard: is(superAdmin),
} as DashboardRoute;

export const promotionCodeListRoute = {
  path: '/dashboard/admin/promotion-codes',
  component: PromotionCodeList,

  guard: is(superAdmin),
} as DashboardRoute;

export const orderCreateRoute = {
  path: '/dashboard/admin/orders/new',
  component: OrderCreate,

  guard: is(superAdmin),
} as DashboardRoute;

export const orderEditRoute = {
  path: '/dashboard/admin/orders/:id',
  component: OrderEdit,

  guard: is(superAdmin),
} as DashboardRoute;

export const orderListRoute = {
  path: '/dashboard/admin/orders',
  component: OrderList,

  guard: is(superAdmin),
} as DashboardRoute;

export default [
  userList,
  userEdit,
  organizationForm,
  organizationList,
  customerCreate,
  customerList,
  customerDetail,
  videoCreate,
  videoList,
  videoEdit,
  videoMenuCreate,
  videoMenuList,
  videoMenuEdit,
  promotionCodeListRoute,
  promotionCodeCreateRoute,
  promotionCodeEditRoute,
  orderListRoute,
  orderCreateRoute,
  orderEditRoute,
];
